import {useFlags as useLDFlags} from 'launchdarkly-react-client-sdk';

export const useFlags = () => {
  const flags = useLDFlags();

  // Rename the LaunchDarkly flag names
  return {
    featuresManagerIntegration: !!flags.acornsFeaturesManagerIntegration,
    notificationsInPlatformApps: !!flags.notificationsInPlatformApps,
    showBrowser: !!flags.acornsShowBrowser,
    showVisualAnalysis: !!flags.acornsShowVisualAnalysis,
    showCreateNewOrder: !!flags.acornsShowCreateNewOrder,
    showDataCollectionsFeature: !!flags.acornsShowDataCollectionsFeature,
    showMapRoutes: !!flags.acornsShowMapRoutes,
    showNotificationSettingsButton: !!flags.accountEnableNotificationSettings,
  };
};
